import classes from "./form.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import TextField from "@/components-library/widgets/text-field";
import Checkbox from "@/components-library/widgets/checkbox";
import Button from "@/components-library/widgets/button";
import Spinner from "@/components-library/widgets/spinner";
import * as appSlice from "@/app/app.slice";
import Modal from "@/components-library/widgets/modal";
import TextArea from "@/components-library/widgets/text-area";
import Iubenda from "react-iubenda-policy";
function Form({
  name,
  surname,
  businessName,
  phone,
  email,
  requestText,
  onEmailChange,
  onNameChane,
  onSurnameChange,
  onPhoneChange,
  onRequestTextChange,
  onBuisinessNameChange,
  onSendReuqestClick,
  isSendRequestEnabled,
  isPravacySelcted,
  onPrivacySelect,
  vatNumber,
  onVatNumberChane,
  status,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.form}
    >
      <Modal isOpen={status === appSlice.Status.ASKING}>
        <Spinner />
      </Modal>
      <Label
        tag="p"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.header}
      >
        Raccontaci del tuo progetto e scopri come possiamo aiutarti a
        svilupparlo grazie alla finanza agevolata!
      </Label>

      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.textField}
      >
        <Label tag="p" size="md" align="start" color="secondary">
          Nome *
        </Label>
        <TextField
          type="text"
          isEnabled={true}
          onChange={onNameChane}
          value={name}
        />
      </Flex>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.textField}
      >
        <Label tag="p" size="md" align="start" color="secondary">
          Cognome *
        </Label>
        <TextField
          type="text"
          isEnabled={true}
          onChange={onSurnameChange}
          value={surname}
        />
      </Flex>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.textField}
      >
        <Label tag="p" size="md" align="start" color="secondary">
          Ragione sociale *
        </Label>
        <TextField
          type="text"
          isEnabled={true}
          onChange={onBuisinessNameChange}
          value={businessName}
        />
      </Flex>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.textField}
      >
        <Label tag="p" size="md" align="start" color="secondary">
          Telefono *
        </Label>
        <TextField
          type="text"
          isEnabled={true}
          onChange={onPhoneChange}
          value={phone}
        />
      </Flex>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.textField}
      >
        <Label tag="p" size="md" align="start" color="secondary">
          Email *
        </Label>
        <TextField
          type="text"
          isEnabled={true}
          onChange={onEmailChange}
          value={email}
        />
      </Flex>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.textArea}
      >
        <Label tag="p" size="md" align="start" color="secondary">
          Richiesta *
        </Label>
        <TextArea
          name=""
          rows={4}
          onChange={onRequestTextChange}
          defaultValue={""}
        />
      </Flex>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.textField}
      >
        <Label tag="p" size="md" align="start" color="secondary">
          P.iva
        </Label>
        <TextField
          type="text"
          isEnabled={true}
          onChange={onVatNumberChane}
          value={vatNumber}
        />
      </Flex>
      <Flex align="center" direction="row" justify="flex-start">
        <Checkbox
          name="all"
          label="Ho letto e accettato l’Informativa sulla "
          isChecked={isPravacySelcted}
          isEnabled={true}
          onClick={onPrivacySelect}
          className={classes.checkbox}
        />
        <Iubenda id={60147723} type="privacy" styling="white">
          Privacy Policy
        </Iubenda>
      </Flex>
      <Button
        onClick={onSendReuqestClick}
        isEnabled={isSendRequestEnabled}
        size="sm"
        color="primary"
        className={classes.button}
      >
        INVIA MESSAGGIO
      </Button>
    </Flex>
  );
}

export default Form;
